import { render } from "./UserFunctionModalSwitch.vue?vue&type=template&id=c735c2d8"
import script from "./UserFunctionModalSwitch.vue?vue&type=script&lang=js"
export * from "./UserFunctionModalSwitch.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__